export const siteSettings = {
  name: "Gemi Live",
  link: "https://gemilive.net",
  email: "support@gemilive.net",
  appLink: "https://app.gemilive.net",
};
